import I18n from 'i18n-js';

import {
  Listing,
  core_apimessages_Listing_ListingType,
} from './rql';

import { IUser } from './components/user_context_provider';

function offersEnabled(listing: Listing) {
  return listing.listingType === core_apimessages_Listing_ListingType.MAKE_AN_OFFER;
}

export function getWatchNudgeText(user: IUser, listing: Listing) {
  if (!user.loggedOut || offersEnabled(listing)) return;
  return I18n.t('commons.nudgeManager.watchNudge');

}

export function getOfferNudgeText(user: IUser) {
  if (user.loggedOut) {
    return I18n.t('commons.nudgeManager.negotiate');
  }

  // TODO - we would like to show this to logged in users
  // who haven't made offers yet; Rails equivalent:
  // - elsif !safe_current_user.as_buyer.has_made_an_offer?
  // return I18n.t('commons.nudgeManager.saveMoney');
}
